import { useStoreState } from 'easy-peasy';

const usePersonification = _ => {
	const personify = useStoreState(state => state.me.personify);
	return [personify.target.id !== '', personify.target.id !== '' ? personify.target : null];
};

export default usePersonification;
